import React, { useContext, useEffect, useState } from 'react'
import { SidebarComponent, TableDivisiDark, TableDivisiLight, TableUserDark, TableUserLight } from '../../components'
import { Col, Row, Tab, Tabs } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive';
import { AuthContext, ThemeContext } from '../../auth';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import Swal from 'sweetalert2';
import RingLoader from 'react-spinners/RingLoader';


function User() {

    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const { showSidebar, tokens } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [dataUser, setDataUser] = useState([]);
    const [listDivisi, setListDivisi] = useState([]);
    const [listDivisiTable, setListDivisiTable] = useState([]);
    const [loading, setLoading] = useState(true);
    const tokenUser = tokens?.token;
    const navigate = useNavigate();

    const retrieveUser = () => {
        setLoading(true);
        const startTime = Date.now();

        axios.get(`/account/users/`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Token ` + tokenUser,
            },
        })
            .then(res => {

                const validData = res.data.filter(item => item.is_superuser === false);
                // setListUser(validData);
                setDataUser(validData);

                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            })
            .catch(err => {

                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);

                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });
                    } else {
                        console.error(err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Gagal memuat data pada server!',
                        });
                    }
                }, delay);

            });
    };

    const retrieveDivisi = () => {
        setLoading(true);
        const startTime = Date.now();

        axios.get(`/account/division/`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                withCredentials: true,
                Authorization: `Token ` + tokenUser,
            },
        })
            .then(res => {

                const validData = res.data.filter(item => item.group_name !== "Administrator");

                setListDivisiTable(validData)

                setListDivisi(res.data);

                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            })
            .catch(err => {

                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);

                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });
                    } else {
                        console.error(err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Gagal memuat data pada server!',
                        });
                    }
                }, delay);

            });
    };

    useEffect(() => {
        if (tokenUser !== undefined) retrieveUser()
        if (tokenUser !== undefined) retrieveDivisi()
    }, [tokenUser]);

    const [listUser, setListUser] = useState([]);

    useEffect(() => {
        const dataTableFilter = dataUser.map(({ ...rest }) => rest);

        setListUser(
            dataTableFilter.map((data) => {
                const group = listDivisi.find((group) => group.name === data.group[0]);

                const groupName = group ? group.name : '';

                return {
                    ...data,
                    group_name: groupName,
                };
            })
        );
    }, [dataUser, listDivisi]);

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            {loading && (
                <div id={theme === 'light' ? 'loading-overlay-dark' : 'loading-overlay-light'}>
                    <RingLoader
                        size={80}
                        color={theme === 'light' ? '#D2DC02' : '#10B1AA'}
                    />
                </div>
            )}
            {!loading && (
                <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                    style={{
                        width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '80px' : '210px'})`,
                        marginLeft: isMobile ? '0px' : showSidebar ? '80px' : '210px',
                        transition: '0.8s'
                    }}
                >
                    <div className={isMobile ? '' : 'ms-3'}>
                        <Row >
                            <Col xs={12} lg={6} className='text-start'>
                                <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '28px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                    Daftar User
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div className={isMobile ? 'pt-4' : 'mx-3 pt-4'} >
                        <Tabs
                            id="controlled-tab-meeting"
                            defaultActiveKey="pegawai"
                            fill
                            style={{ fontFamily: 'Poppins-Regular' }}
                        >
                            <Tab eventKey="pegawai" title="Pegawai">
                                {theme === 'light' ?
                                    <TableUserDark
                                        tokenUser={tokenUser}
                                        listUser={listUser}
                                        retrieveUser={retrieveUser}
                                        listDivisi={listDivisi}
                                    />
                                    :
                                    <TableUserLight
                                        tokenUser={tokenUser}
                                        listUser={listUser}
                                        retrieveUser={retrieveUser}
                                        listDivisi={listDivisi}
                                    />
                                }
                            </Tab>
                            <Tab eventKey="divisi" title="Divisi">
                                {theme === 'light' ?
                                    <TableDivisiDark
                                        tokenUser={tokenUser}
                                        listDivisiTable={listDivisiTable}
                                        retrieveDivisi={retrieveDivisi}
                                    />
                                    :
                                    <TableDivisiLight
                                        tokenUser={tokenUser}
                                        listDivisiTable={listDivisiTable}
                                        retrieveDivisi={retrieveDivisi}
                                    />
                                }
                            </Tab>

                        </Tabs>


                    </div>
                    <br />
                    <br />
                </div>
            )}
        </div>
    );
}

export default User
